export default __webpack_public_path__ + "static/img16-9696f50c2cbe6a01eabf3b18746a90e3.png";